import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TenantContext from "../../../context/tenant/TenantContext";
import AuthContext from "../../../context/auth/AuthContext";
import LandLordContext from "../../../context/landlord/LandLordContext";
import "react-toastify/dist/ReactToastify.css";
import useTranslator from "../../../hooks/useTranslator";
import { haveValue, toast } from "../../../helper/common";
import { useCookies } from "react-cookie";
import Slider from "rc-slider";
import ProfileTable from "../../../components/Profiles/ProfilesTable";
import SkorDefaultLoader from "../../../assets/img/skorDefaultLoader.gif";
import AddAgentModal from "../profile-request/AddAgentModal";
import { WORKSPACE_ROLES_CAPABILITIES } from "../../../Utils/workspaceRoleCapabilities";
import DataLoadedError from "../../../components/ErrorModal/DataLoadedError";

const CreatedTenant = () => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const { workspaceId } = useParams();
  const authContext = useContext(AuthContext);
  const {
    user,
    userType,
    loadMyNotifications,
    setErrorDataLoading,
    errorDataLoading,
  } = authContext;

  const tenantContext = useContext(TenantContext);
  const { shareProfile } = tenantContext;

  const landLordContext = useContext(LandLordContext);
  const {
    loadAgencyProfile,
    loadProfilesLandlord,
    properties,
    loadProperties,
  } = landLordContext;
  const [rentPercentage, setRentPercentage] = useState(
    user?.rent_percentage ?? 1,
  );
  const [rentDoc, setRentDoc] = useState("current_annual_income");

  const queryParameters = new URLSearchParams(window.location.search);

  //toggling between full and basic profile
  const [loading, setLoading] = useState(false);

  const [removeCookie] = useCookies(["sharedProfileLink"]);
  const [effortRateModal, setEffortRateModal] = useState(false);

  const [filters, setFilters] = useState({
    createdAt: "desc",
    myScore: "",
  });

  const [profiles, setProfiles] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(15);
  const [total, setTotal] = useState(0);
  const [searchVal, setSearchVal] = useState("");
  const loadingRef = useRef(false);

  const [assignLLModal, setAssignLLModal] = useState({
    tenant_id: null,
    openModal: false,
  });

  const [effortRatePecentage, setEffortRatePecentage] =
    useState(rentPercentage);

  useEffect(() => {
    let userid = localStorage.getItem("saveduserid");
    if (haveValue(user?._id) || haveValue(userid)) {
      useeffectfunc();
    }
    if (haveValue(userid)) {
      loadProperties(userid);
    }
  }, [filters]);

  useEffect(() => {
    if (haveValue(user?.rent_percentage)) {
      setRentPercentage(user?.rent_percentage);
      setEffortRatePecentage(user?.rent_percentage);
    }
    if (haveValue(user?.rent_from)) {
      setRentDoc(user?.rent_from);
    }
    useeffectfunc();
  }, [user, workspaceId]);

  const useeffectfunc = async () => {
    const sharedProfileLink = queryParameters.get("sharedProfileLink");
    const navigateTo = queryParameters.get("navigateTo");
    if (haveValue(navigateTo)) {
      navigate(`/${navigateTo}`);
    }
    if (haveValue(sharedProfileLink)) {
      await importProfileRedirect();
    } else {
      loadData();
    }
  };

  const loadData = async (requestedPage = page, search = searchVal) => {
    if (loadingRef.current && !search) return;
    loadingRef.current = true;

    setLoading(true);
    try {
      let userid = localStorage.getItem("saveduserid");

      let response;
      // if (user?.isParentLL && haveValue(user?.agency_id)) {
      //   response = await loadAgencyProfile(
      //     user?.agency_id?._id,
      //     requestedPage,
      //     limit,
      //     search,
      //     true
      //   );
      // } else
      if (user?._id) {
        response = await loadProfilesLandlord(user?._id, "full", {
          searchVal: search,
          page: requestedPage,
          limit,
          llCreatedOnly: true,
        });
      }

      if (!response) {
        return;
      }

      const { data, total: newTotal } = response;

      setTotal(newTotal);
      setPage(requestedPage);

      setProfiles((prev) => (requestedPage === 1 ? data : [...prev, ...data]));
      loadMyNotifications(userid, userType);
    } catch (err) {
      console.error(err);
      setErrorDataLoading(true);
    } finally {
      setLoading(false);
      loadingRef.current = false;
    }
  };

  const importProfileRedirect = async () => {
    let userid = localStorage.getItem("saveduserid");
    const sharedProfileLink = queryParameters.get("sharedProfileLink");

    if (haveValue(sharedProfileLink)) {
      const done = await shareProfile(
        sharedProfileLink,
        userid,
        "null",
        "full",
        { shareType: "tLink" },
      );
      removeCookie("sharedProfileLink", { maxAge: 1800 });
      if (done) {
        toast.success(_t("profileImported"));
      }
      loadData();
      navigate(`/${workspaceId}/profile-request`);
    }
  };

  const searchTenant = (e) => {
    const q = e.target.value;
    setSearchVal(q);
    setPage(1);
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setProfiles([]);
      loadData(1, searchVal);
    }, 200);

    return () => clearTimeout(delayDebounceFn);
  }, [searchVal]);

  const checkSalary = (user) => {
    if (haveValue(user?.gurantor_id) && haveValue(user?.gurantor_id?._id)) {
      if (user?.gurantor_id?.algoanIncome) {
        let monthlyIncome = parseInt(
          user?.gurantor_id?.algoanIncome?.monthlyAmount,
        );
        let recorded_annual_salary = monthlyIncome * 12;

        let userIncome = parseInt(
          haveValue(user?.gurantor_id?.current_annual_income)
            ? user?.gurantor_id?.current_annual_income
            : 0,
        );
        let salaryMatch = Math.round(
          (recorded_annual_salary / userIncome) * 100,
        );

        return {
          matched: salaryMatch,
          salary: recorded_annual_salary,
        };
      }
    } else {
      if (user?.algoanIncome) {
        let monthlyIncome = parseInt(user?.algoanIncome?.monthlyAmount);
        let recorded_annual_salary = monthlyIncome * 12;

        let userIncome = parseInt(
          haveValue(user.current_annual_income)
            ? user.current_annual_income
            : 0,
        );
        let salaryMatch = Math.round(
          (recorded_annual_salary / userIncome) * 100,
        );
        return {
          matched: salaryMatch,
          salary: recorded_annual_salary,
        };
      }
    }
  };

  const openAssignLLModal = (tenant_id) => {
    setAssignLLModal((prev) => ({
      ...prev,
      tenant_id: tenant_id,
      openModal: true,
    }));
  };
  const handleCloseModal = () => {
    loadData();
    setAssignLLModal((prev) => ({
      ...prev,
      tenant_id: null,
      openModal: false,
    }));
  };

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
          document.body.offsetHeight - 500 &&
        !loadingRef.current &&
        profiles.length < total
      ) {
        loadData(page + 1);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [page, total, profiles]);
  const handleNavigateCreate = () => {
    navigate(`/${workspaceId}/tenant-check/create`);
  };

  return (
    <>
      <div
        className="main-page-wrapper mb-4 position-relative profileRequestWrapper"
        onClick={() => setEffortRateModal(false)}
      >
        <div className="profile-page marless mobile-max-less mobile-max-lesshead">
          <div className="number-properties numberProperties">
            <h2>{_t("tenantChecks")}</h2>
            <div className="d-flex gap-2">
              <div className="Search-bar searchbar_cls">
                <div className="search_bar_edit">
                  <a href="#">
                    <img
                      src="/images/search-icon-grey.svg"
                      alt=""
                      className="searchIcon"
                    />
                  </a>
                  <input
                    type="text"
                    className="custom-input mb-0 input01"
                    onChange={searchTenant}
                    value={searchVal}
                    placeholder={_t("search")}
                  />
                </div>
              </div>
              {WORKSPACE_ROLES_CAPABILITIES?.tenantChecks?.add?.includes(
                user?.current_workspace_role,
              ) && (
                <button
                  className="addGuarantorButton d-flex align-items-center"
                  onClick={handleNavigateCreate}
                >
                  <img src="/images/add-white.svg" />
                  {_t("addTenantProfile")}
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="tabs-box-pattern tabs-box-pattern-2 big_tablebg">
          {errorDataLoading ? (
            <DataLoadedError />
          ) : (
            <div className="tabs-item d-block p-0">
              <ProfileTable
                profile={profiles}
                properties={properties}
                loadData={loadData}
                user={user}
                openAssignLLModal={openAssignLLModal}
                checkSalary={checkSalary}
                rentPercentage={rentPercentage}
                rentDoc={rentDoc}
                tenantChecks={true}
              />
              {loading ? (
                <div className="defaultSkorLoaderParent mt-3">
                  <img
                    src={SkorDefaultLoader}
                    className="defaultSkorLoaderSmall"
                    alt="Example"
                  />
                </div>
              ) : (
                profiles?.length === 0 && (
                  <div className="defaultSkorLoaderParent mt-3">
                    {_t(
                      "noProfilesFound",
                      "Used text if there is no profile in landlord's tenant profile",
                    )}
                  </div>
                )
              )}
            </div>
          )}
        </div>
      </div>
      {assignLLModal.openModal && (
        <AddAgentModal
          tenant_id={assignLLModal.tenant_id}
          openModal={assignLLModal.openModal}
          handleCloseModal={handleCloseModal}
        />
      )}
    </>
  );
};

export default CreatedTenant;
